import LoadingButton from '@mui/lab/LoadingButton';
import {
    Alert,
    Box,
    Checkbox,
    CircularProgress,
    Container,
    DialogActions,
    DialogContent,
    Divider,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    Tab,
    Tabs,
    TextField,
    Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import {TabContext, TabList, TabPanel} from '@mui/lab';
import {useFormik} from 'formik';
import {useSnackbar} from 'notistack';
import {useCallback, useEffect, useState} from 'react';
import server from '../../../global/server';
import useHandleErrors from '../../../hooks/useHandleErrors';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '../../../context/AuthContext';
import axios from 'axios';
import SelectBank from '../../../components/SelectBank';
import * as Yup from 'yup';
import { validaCNPJ, validaCPF } from '../../../global/cpfCnpj';
import { useFetch } from '../../../hooks/useFetch';
import ProfileForm from './UserForm';

const RegisterSchema = Yup.object().shape({
    document_type: Yup.string().required(),
    document: Yup.string()
        .required('Campo obrigatório')
        .when('document_type', {
            is: value => value === 'CPF',
            then: schema =>
                schema
                    .length(11, 'Documento inválido')
                    .test('invalid-cpf', 'Documento inválido', cpf => validaCPF(cpf)),
            otherwise: schema =>
                schema
                    .length(14, 'Documento incompleto')
                    .test('invalid-cnpj', 'Documento inválido', cnpj => validaCNPJ(cnpj)),
        }),
    holder: Yup.string().required('Campo obrigatório'),
    zipcode: Yup.string().min(8, 'Mínimo de 8 digitos').required('Campo obrigatório'),
    complement: Yup.string().required('Campo obrigatório'),
    number: Yup.string().required('Zero caso não haja.'),
    bank_number: Yup.string().max(3).required('Campo obrigatório'),
    agency_number: Yup.string().max(4, 'Máximo 4 dígitos').test('invalid-agency-number','Dado inválido' ,value=>Number.isInteger(Number(value)) ).required('Campo obrigatório'),
    agency_digit: Yup.string().nullable().max(1, 'Máximo 1 dígitos'),
    account_number: Yup.string().max(12, 'Máximo 13 dígitos').test('invalid-account-number','Dado inválido' ,value=>Number.isInteger(Number(value)) ).required('Campo obrigatório'),
    account_digit: Yup.string().max(2, 'Máximo 2 dígitos').test('invalid-account-digit','Dado inválido' ,value=>Number.isInteger(Number(value)) ).required('Campo obrigatório'),
});

export default ({data:person, close}) => {

    const {data, mutate, isLoading, error} = useFetch(`/person/${person.id}`)

    if(isLoading) return <CircularProgress />
    if(error ||  !data) return <Typography>{error.message}</Typography>

    return <ProfileForm data={data} mutate={mutate} closse={close} />

    // const {user} = useAuth();
    // const navigation = useNavigate();
    // const {enqueueSnackbar} = useSnackbar();
    // const [errs, setErrs] = useState();
    // useHandleErrors(errs);
    // const [value, setValue] = useState(1);

    // function a11yProps(index) {
    //     return {
    //         id: `profile-tab-${index}`,
    //         'aria-controls': `profile-tabpanel-${index}`,
    //     };
    // }

    // const {
    //     values,
    //     errors,
    //     handleChange,
    //     handleSubmit,
    //     handleBlur,
    //     handleReset,
    //     setValues,
    //     isSubmitting,
    //     setFieldValue,
    //     setFieldError,
    // } = useFormik({
    //     validationSchema: RegisterSchema,
    //     validateOnMount: true,
    //     initialValues: {
    //         approved: false,
    //     },
    //     onSubmit: async (values, {setSubmitting}) => {
    //         try {
    //             setSubmitting(true);
    //             await server.patch(`/backoffice/${data.profile.id}/verify`);
    //             await mutate();
    //             close();
                
    //             enqueueSnackbar('Perfil aprovado');
    //             setSubmitting(false);
    //         } catch (error) {
    //             setSubmitting(false);
    //             setErrs(error);
    //         }
    //     },
    // });

    // useEffect(() => {
    //     if (data) {
    //         setValues({...data.profile, ...data, profile_id: data.profile.id }, true);
    //     }
    // }, [data]);

    // const searchPostalCode = useCallback(async () => {
    //     try {
    //         if (String(values?.zipcode).length === 8) {
    //             setFieldValue('street', '');
    //             setFieldValue('city', '');
    //             setFieldValue('state', '');

    //             const {data} = await axios.get(`https://viacep.com.br/ws/${values.zipcode}/json/`);

    //             if (data.erro) throw 'Erro';
    //             setFieldValue('street', `${data.logradouro}, ${data.bairro}`);
    //             setFieldValue('city', `${data.localidade}`);
    //             setFieldValue('state', `${data.uf}`);
    //         }
    //     } catch (error) {
    //         console.log('E', error);
    //         setFieldError('zipcode', 'CEP Inválido');
    //     }
    // }, [values]);

    // return (
    //     <>
    //         <DialogContent>
    //             <TabContext value={value}>
    //                 <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
    //                     <TabList onChange={(e, newValue) => setValue(newValue)}>
    //                         <Tab label="Usuário" value={1} />
    //                         <Tab label="Perfil" value={2} />
    //                         <Tab label="Dados bancários" value={3} />
    //                     </TabList>
    //                 </Box>
    //                 <TabPanel value={1} sx={{px: 0}}>
    //                     <Stack direction="row" pb={2} justifyContent="space-between">
    //                         <Alert sx={{fontSize: 11}}>
    //                             Cadastrado desde{' '}
    //                             {new Date(values.createdAt).toLocaleString('pt-BR')}
    //                         </Alert>
    //                     </Stack>

    //                     <Grid container rowSpacing={2}>
    //                         <Grid item xs={12}>
    //                             <TextField
    //                                 variant="outlined"
    //                                 fullWidth
    //                                 required
    //                                 label="Nome"
    //                                 type="text"
    //                                 name="name"
    //                                 onChange={handleChange}
    //                                 onBlur={handleBlur}
    //                                 value={values.name}
    //                                 error={errors.name}
    //                                 helperText={errors.name}
    //                             />
    //                         </Grid>
    //                         <Grid item xs={12}>
    //                             <TextField
    //                                 variant="outlined"
    //                                 fullWidth
    //                                 required
    //                                 label="Email"
    //                                 type="text"
    //                                 name="email"
    //                                 onChange={handleChange}
    //                                 onBlur={handleBlur}
    //                                 value={values.email}
    //                                 error={errors.email}
    //                                 helperText={errors.email}
    //                             />
    //                         </Grid>
    //                         <Grid item xs={12}>
    //                             <TextField
    //                                 variant="outlined"
    //                                 fullWidth
    //                                 required
    //                                 label="Qual sua área de trabalho?"
    //                                 type="text"
    //                                 name="short_description"
    //                                 onChange={handleChange}
    //                                 onBlur={handleBlur}
    //                                 value={values.short_description}
    //                                 error={Boolean(errors.short_description)}
    //                                 helperText={errors.short_description}
    //                                 InputProps={{
    //                                     maxLength: 40,
    //                                     endAdornment: (
    //                                         <InputAdornment sx={{fontSize: 11}} position="end">
    //                                             {40 -
    //                                                 (Boolean(values.short_description)
    //                                                     ? values.short_description.length
    //                                                     : 0)}
    //                                         </InputAdornment>
    //                                     ),
    //                                 }}
    //                             />
    //                         </Grid>
    //                         <Grid item xs={12}>
    //                             <TextField
    //                                 variant="outlined"
    //                                 multiline
    //                                 minRows={4}
    //                                 fullWidth
    //                                 required
    //                                 label="Conte sobre você e sua história"
    //                                 type="text"
    //                                 name="description"
    //                                 onChange={handleChange}
    //                                 onBlur={handleBlur}
    //                                 value={values.description}
    //                                 error={Boolean(errors.description)}
    //                                 helperText={errors.description}
    //                                 InputProps={{
    //                                     maxLength: 250,
    //                                     endAdornment: (
    //                                         <InputAdornment
    //                                             sx={{
    //                                                 position: 'absolute',
    //                                                 top: 25,
    //                                                 right: 5,
    //                                                 fontSize: 11,
    //                                             }}
    //                                             position="start">
    //                                             {250 -
    //                                                 (Boolean(values.short_description)
    //                                                     ? values.short_description.length
    //                                                     : 0)}
    //                                         </InputAdornment>
    //                                     ),
    //                                 }}
    //                             />
    //                         </Grid>
    //                     </Grid>
    //                 </TabPanel>
    //                 <TabPanel value={2} sx={{px: 0}}>
    //                     {values.profile && (
    //                         <Grid container rowSpacing={2} columnSpacing={2}>
    //                             <Grid item xs={12}>
    //                                 <FormControl fullWidth>
    //                                     <InputLabel id="document-type-label">
    //                                         Tipo do documento
    //                                     </InputLabel>
    //                                     <Select
    //                                         labelId="document-type-label"
    //                                         id="document-type"
    //                                         value={values.document_type}
    //                                         label="Tipo do documento"
    //                                         name="document_type"
    //                                         onChange={handleChange}>
    //                                         <MenuItem value="CPF">CPF</MenuItem>
    //                                         <MenuItem value="CNPJ">CNPJ</MenuItem>
    //                                     </Select>
    //                                 </FormControl>
    //                             </Grid>
    //                             <Grid item xs={12}>
    //                                 <TextField
    //                                     variant="outlined"
    //                                     fullWidth
    //                                     required
    //                                     label="Documento (CPF ou CNPJ)"
    //                                     name="document"
    //                                     onChange={handleChange}
    //                                     value={values.document}
    //                                     error={Boolean(errors.document)}
    //                                     helperText={errors.document}
    //                                     InputProps={{
    //                                         maxLenght: 14,
    //                                     }}
    //                                 />
    //                             </Grid>
    //                             <Grid item xs={12}>
    //                                 <TextField
    //                                     variant="outlined"
    //                                     fullWidth
    //                                     required
    //                                     label="Nome completo ou Razão Social"
    //                                     type="text"
    //                                     name="holder"
    //                                     onChange={handleChange}
    //                                     onBlur={handleBlur}
    //                                     value={values.holder}
    //                                     error={Boolean(errors.holder)}
    //                                     helperText={errors.holder}
    //                                     InputProps={{
    //                                         maxLenght: 14,
    //                                     }}
    //                                 />
    //                             </Grid>
    //                             <Grid item xs={12}>
    //                                 <TextField
    //                                     variant="outlined"
    //                                     fullWidth
    //                                     required
    //                                     label="CEP"
    //                                     type="number"
    //                                     name="zipcode"
    //                                     onChange={handleChange}
    //                                     onBlur={searchPostalCode}
    //                                     value={values.zipcode}
    //                                     error={Boolean(errors.zipcode)}
    //                                     helperText={`${values.street}, ${values.city}-${values.state}`}
    //                                 />
    //                             </Grid>
    //                             <Grid item xs={12} md={9}>
    //                                 <TextField
    //                                     variant="outlined"
    //                                     fullWidth
    //                                     required
    //                                     label="Complemento"
    //                                     type="text"
    //                                     name="complement"
    //                                     onChange={handleChange}
    //                                     onBlur={handleBlur}
    //                                     value={values.complement}
    //                                     error={Boolean(errors.complement)}
    //                                     helperText={errors.complement}
    //                                 />
    //                             </Grid>
    //                             <Grid item xs={12} md={3}>
    //                                 <TextField
    //                                     variant="outlined"
    //                                     fullWidth
    //                                     required
    //                                     label="Número"
                                         
    //                                     name="number"
    //                                     onChange={handleChange}
    //                                     onBlur={handleBlur}
    //                                     value={values.number}
    //                                     error={Boolean(errors.number)}
    //                                     helperText={errors.number}
    //                                 />
    //                             </Grid>
    //                         </Grid>
    //                     )}
    //                 </TabPanel>
    //                 <TabPanel value={3} sx={{px: 0}}>
    //                     {values.profile && (
    //                         <Grid container rowSpacing={2} columnSpacing={2}>
    //                             <Grid item xs={12} md={12}>
    //                                 <SelectBank
    //                                     name="bank_number"
    //                                     value={values.bank_number}
    //                                     onChange={setFieldValue}
    //                                     error={Boolean(errors.bank_number)}
    //                                     helperText={errors.bank_number}
    //                                 />
    //                             </Grid>
    //                             <Grid item xs={12} md={9}>
    //                                 <TextField
    //                                     variant="outlined"
    //                                     fullWidth
    //                                     required
    //                                     label="Agencia"
                                         
    //                                     name="agency_number"
    //                                     onChange={handleChange}
    //                                     onBlur={handleBlur}
    //                                     value={values.agency_number}
    //                                     error={Boolean(errors.agency_number)}
    //                                     helperText={errors.agency_number}
    //                                 />
    //                             </Grid>
    //                             <Grid item xs={12} md={3}>
    //                                 <TextField
    //                                     variant="outlined"
    //                                     fullWidth
    //                                     required
    //                                     label="Digito"
    //                                     type="text"
    //                                     name="agency_digit"
    //                                     onChange={handleChange}
    //                                     onBlur={handleBlur}
    //                                     value={values.agency_digit}
    //                                     error={Boolean(errors.agency_digit)}
    //                                     helperText={errors.agency_digit}
    //                                 />
    //                             </Grid>
    //                             <Grid item xs={12} md={9}>
    //                                 <TextField
    //                                     variant="outlined"
    //                                     fullWidth
    //                                     required
    //                                     label="Conta"
                                         
    //                                     name="account_number"
    //                                     onChange={handleChange}
    //                                     onBlur={handleBlur}
    //                                     value={values.account_number}
    //                                     error={Boolean(errors.account_number)}
    //                                     helperText={errors.account_number}
    //                                 />
    //                             </Grid>
    //                             <Grid item xs={12} md={3}>
    //                                 <TextField
    //                                     variant="outlined"
    //                                     fullWidth
    //                                     required
    //                                     label="Digito"
    //                                     type="text"
    //                                     name="account_digit"
    //                                     onChange={handleChange}
    //                                     onBlur={handleBlur}
    //                                     value={values.account_digit}
    //                                     error={Boolean(errors.account_digit)}
    //                                     helperText={errors.account_digit}
    //                                 />
    //                             </Grid>
    //                             <Grid item xs={12} md={12}>
    //                                 <FormControl fullWidth>
    //                                     <InputLabel id="account-type-label">
    //                                         Tipo do conta
    //                                     </InputLabel>
    //                                     <Select
    //                                         labelId="account-type-label"
    //                                         id="account-type"
    //                                         value={values.account_type}
    //                                         error={Boolean(errors.account_type)}
    //                                         helperText={errors.account_type}
    //                                         label="Tipo da conta"
    //                                         name="account_type"
    //                                         onChange={handleChange}>
    //                                         <MenuItem value="checking">Corrente</MenuItem>
    //                                         <MenuItem value="saves">Poupança</MenuItem>
    //                                     </Select>
    //                                 </FormControl>
    //                             </Grid>
    //                         </Grid>
    //                     )}
    //                 </TabPanel>
    //             </TabContext>
    //         </DialogContent>
    //         <Divider />
    //         <DialogActions>
    //             <LoadingButton
    //                 variant="contained"
    //                 disabled={values?.approved || Boolean(Object.keys(errors).length)}
    //                 loading={isSubmitting}
    //                 onClick={handleSubmit}>
    //                 {values?.profile?.approved ? 'Anfitriao aprovado' : 'Aprovar anfitrião'}
    //             </LoadingButton>
    //         </DialogActions>
    //     </>
    // );
};
